import { observer } from 'mobx-react';
import React, { Component } from 'react';
import ExpressionResultModel from 'stores/models/ExpressionResult';
import { IOperon } from 'stores/models/LacOperon';
import OperonExpression from './OperonExpression';

interface IProps {
  model?: ExpressionResultModel | null;
}

const NONE = 'None';

class View extends Component<IProps> {
  getOperonExpression(model?: IOperon) {
    return model && <OperonExpression model={model} />;
  }

  render() {
    const { bacterial, lacZ, lacA, output, plasmid } = { ...this.props.model };
    const expressionBacterial = this.getOperonExpression(bacterial?.operon);
    const expressionPlasmid = this.getOperonExpression(plasmid?.operon);
    const sortedOutput = output?.split('').sort().reverse();

    return (
      <div>
        <div className='is-flex'>
          <span className='has-text-weight-semibold'>
            {expressionBacterial || NONE}
          </span>{' '}
          <span className='ml-3'>/</span>
        </div>
        <div className='is-flex pl-4'>
          <span className='mr-3'>F</span>{' '}
          <span className='has-text-weight-semibold'>
            {expressionPlasmid || NONE}
          </span>
        </div>
        <p>
          LacZ: <span className='has-text-weight-semibold'>{lacZ || NONE}</span>
        </p>
        <p>
          LacA: <span className='has-text-weight-semibold'>{lacA || NONE}</span>
        </p>
        <p>
          Output:{' '}
          <span className='has-text-weight-semibold'>
            {output ? sortedOutput : NONE}
          </span>
        </p>
      </div>
    );
  }
}

const ExpressionResult = observer(View);
export default ExpressionResult;
